import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

export default class TextInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tempValue: null,
      valid: true,
    };

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.selected !== nextProps.selected) {
      return true;
    }
    if (this.state.tempValue !== nextState.tempValue) {
      return true;
    }
    return false;
  }

  static validate(num) {
    return +num.replace(',', '.');
  }

  handleKeyUp(event) {
    // eslint-disable-next-line default-case
    switch (event.keyCode) {
      case 27: // esc
        this.resetInput();
      // fall through
      case 13: // enter
        event.target.blur();
        break;
    }
  }

  resetInput() {
    this.setState({
      tempValue: null,
      valid: true,
    });
  }

  handleBlur() {
    if (this.state.tempValue === null) {
      // Dont update filter if value never changed
      return;
    }

    const newValue = TextInput.validate(
      this.state.tempValue || this.props.default
    );

    this.resetInput();

    if (isNaN(newValue)) {
      return;
    }

    this.props.onChange({
      id: this.props.id,
      value: newValue,
    });
  }

  handleChange(event) {
    this.setState({
      tempValue: event.target.value,
      valid: !isNaN(TextInput.validate(event.target.value)),
    });
  }

  getValue() {
    // Want to be able to erase the entire input field
    if (this.state.tempValue !== null && this.state.tempValue.length === 0) {
      return '';
    }

    return this.state.tempValue || this.props.selected || this.props.default;
  }

  render() {
    return (
      <S.Input
        type="text"
        invalid={!this.state.valid}
        value={this.getValue()}
        onKeyUp={this.handleKeyUp}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }
}

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  default: PropTypes.string.isRequired,
  selected: PropTypes.number,
};

TextInput.defaultProps = {
  selected: null,
};
